import type { ForNodeType } from "@/components/features/_model/types/auto-generator-for-view-model";

type Props = {
	doNotCountKidsAsStock: ForNodeType<boolean>;

	onSetViewModel: (
		values: {
			key: "doNotCountKidsAsStock";
			value: ForNodeType<boolean>;
		}[],
	) => void;
};

export const useDoNotCountKidsAsStock = ({ doNotCountKidsAsStock, onSetViewModel }: Props) => {
	return {
		doNotCountKidsAsStock,
		onSetDoNotCountKidsAsStock: (value: boolean) => {
			onSetViewModel([
				{
					key: "doNotCountKidsAsStock",
					value: {
						...doNotCountKidsAsStock,
						isEdited: true,
						value,
					},
				},
			]);
		},
	};
};
